import alyssaPic from "@/public/images/artists/alyssa.png";
import { Artist } from "@/types/types";

export const alyssa = {
  id: "129",
  name: "Alyssa",
  image: alyssaPic,
  description: `Alyssa's voice resonates with a distinctive blend of confidence and allure, emblematic of contemporary R&B pop. With seamless transitions between soulful melodies and rhythmic verses, Alyssa demonstrates a versatile rap ability that adds depth and dynamism to her vocal repertoire.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Falyssa-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Hip Hop", "Pop", "Unprocessed"],
      secondary: ["Alluring"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 52,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
